import type { CoreConfiguration, UIElement } from '@adyen/adyen-web';
import type { IntlShape } from 'react-intl/src/types';

import type { MoneyFragment } from '@/graphql/saleor/api';

export type GatewayPaymentMethod = UIElement;

export type TransactionType = 'TOKENIZE' | 'DEPOSIT' | 'BALANCE' | 'FULL';
export type TransactionAction = 'AUTHORIZE' | 'TOKENIZE';

export const PAYMENT_TYPES = {
  CARD: 'card',
  VISA: 'visa',
  ALIPAY: 'alipay',
  APPLE_PAY: 'applepay',
  APPLE_PAY_EXPRESS: 'applepay_express',
  PAY_WITH_GOOGLE: 'paywithgoogle',
  GOOGLE_PAY: 'googlepay',
  UNION_PAY: 'unionpay',
  PAYPAL: 'paypal',
  PAYPAL_EXPRESS: 'paypal_express',
  KLARNA_PAYNOW: 'klarna_paynow',
  KLARNA_ACCOUNT: 'klarna_account',
  AFFIRM: 'affirm',
  SCHEME: 'scheme',
  IDEAL: 'ideal',
  TWINT: 'twint',
  BANCONTACT: 'bcmc',
  FACILYPAY_3X: 'facilypay_3x',
  FACILYPAY_4X: 'facilypay_4x',
  PAYBYBANK: 'paybybank',
  PAYBYBANK_US: 'paybybank_AIS_DD',
  V12: 'v12',
  CEMBRA: 'cembra_installment',
  CEMBRA_INVOICE: 'cembra_invoice',
  CREDIT_PLUS: 'creditplus',
  AGOS: 'agos',
  ZIP: 'zip',
  OFFLINE: 'offline_banktransfer',
  ORICO_FINANCING: 'orico_financing',
  SMBC: 'smbc',
} as const;
export type PaymentType = (typeof PAYMENT_TYPES)[keyof typeof PAYMENT_TYPES];

export type CardInfo = {
  expiryDate: string;
  holderName?: string;
  id: string;
  last4: string;
};

export type PaymentMethod = {
  extraInfo: CardInfo | null;
  gateway: string;
  type: PaymentType;
};

export type PaymentGatewayConfig = {
  id: string;
  paymentMethods: PaymentMethod[];
};

export type AdyenCheckoutOpts = Pick<
  CoreConfiguration,
  | 'onAdditionalDetails'
  | 'onError'
  | 'onPaymentCompleted'
  | 'onSubmit'
  | 'session'
  | 'clientKey'
  | 'beforeSubmit'
  | 'showPayButton'
> &
  Pick<IntlShape, 'formatMessage'> & {
    countryCode: string;
    locale: string;
    paymentMethodType: PaymentType;
    price: MoneyFragment;
  };

export type MulticardConfig = {
  maxAmount?: number;
  maxPayments?: number;
  minAmount?: number;
  paidMoney?: MoneyFragment;
};

export type AdyenEnv =
  | 'test'
  | 'live'
  | 'live-us'
  | 'live-au'
  | 'live-apse'
  | 'live-in'
  | undefined;

export type PaymentRecord = Partial<PaymentMethod> & {
  amount: number;
  id: string;
  name: string;
};
